var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"table",attrs:{"layout":_vm.layout,"apiUrl":_vm.apiUrl,"paginationSize":_vm.paginationSize,"autoColumns":_vm.autoColumns,"columns":_vm.columns,"paginationSizeSelector":_vm.paginationSizeSelector,"modelKey":_vm.modelKey}})}
var staticRenderFns = []

export { render, staticRenderFns }